'use client';

import { usePathname } from 'next/navigation';
import TabBar from './TabBar';

export default function TabBarWrapper() {
  const pathname = usePathname();
  
  // Only hide tab bar during onboarding or on landing page
  const showTabBar = pathname?.startsWith('/dashboard') || pathname?.startsWith('/filters') || pathname?.startsWith('/chat') || pathname?.startsWith('/quick-filters') || pathname?.startsWith('/help') || pathname?.startsWith('/support') || pathname?.startsWith('/stats') || pathname?.startsWith('/license') || pathname?.startsWith('/referral');

  return (
    <>
      {/* Tab Bar */}
      {showTabBar && <TabBar />}
    </>
  );
} 